export class InformacionFinancieraPj {
    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                header: 'Código',
            },
            corriente: {
                value: 0,
                export: false,
                header: 'Corriente:',
                required: 'Corriente requerido',
            },
            fijo: {
                value: 0,
                export: false,
                header: 'Fijo:',
                required: 'Fijo Requerido',
            },
            otros_activos: {
                value: 0,
                export: false,
                header: 'Otros Activos:',
                required: 'Otros Activos requerido',
            },
            total_activo: {
                value: 0,
                export: false,
                header: 'Total Activos:',
                required: 'Requerido',
            },
            total_ingresos: {
                value: 0,
                export: false,
                header: 'Total de Ingresos:',
                required: 'Totla de ingresos requerido',
            },
            corto_plazo: {
                value: 0,
                export: false,
                header: 'Corto Plazo:',
                required: 'Corto Plazo requerido',
            },
            largo_plazo: {
                value: 0,
                export: false,
                header: 'Largo Plazo:',
                required: 'Largo Plazo requerido',
            },
            total_pasivos: {
                value: 0,
                export: false,
                header: 'Total Pasivos:',
                required: 'Requerido',
            },
            patrimonio: {
                value: 0,
                export: false,
                header: 'Patrimonio (A-P):',
                required: 'Requerido',
            },
            total_egresos: {
                value: 0,
                export: false,
                header: 'Total Egresos:',
                required: 'Total de Egresos requerido',
            }
        }
    }
}